import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Splash() {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [videoEnded, setVideoEnded] = useState(false);

  useEffect(() => {
    // Check if user has already seen the splash screen in this session
    const hasSeenSplash = sessionStorage.getItem('vgoride_splash_seen');
    if (hasSeenSplash) {
      navigate('/', { replace: true });
      return;
    }

    // Play video when component mounts
    if (videoRef.current) {
      videoRef.current.play().catch(err => {
        console.log('Video autoplay failed:', err);
        // If autoplay fails, skip to home after a short delay
        setTimeout(() => navigate('/', { replace: true }), 1000);
      });
    }
  }, [navigate]);

  const handleVideoEnd = () => {
    setVideoEnded(true);
    // Mark that user has seen the splash screen
    sessionStorage.setItem('vgoride_splash_seen', 'true');
    // Navigate to home page
    setTimeout(() => navigate('/', { replace: true }), 300);
  };

  const handleSkip = () => {
    sessionStorage.setItem('vgoride_splash_seen', 'true');
    navigate('/', { replace: true });
  };

  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center z-[9999]">
      <video
        ref={videoRef}
        src="/intro.mp4"
        className={`w-full h-full object-contain transition-opacity duration-500 ${videoEnded ? 'opacity-0' : 'opacity-100'}`}
        onEnded={handleVideoEnd}
        playsInline
        muted
        autoPlay
      />
      
      {/* Skip button */}
      <button
        onClick={handleSkip}
        className="absolute top-8 right-8 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-6 py-2 rounded-full text-sm font-medium transition-all border border-white/20"
        data-testid="skip-intro-btn"
      >
        Skip Intro
      </button>
    </div>
  );
}
